var bodySizes = [
  'base',
  'phone-small',
  'phone',
  'phone-large',
  'tablet-small',
  'tablet',
  'tablet-large',
  'desktop-small',
  'desktop',
  'desktop-large'
];

var comparisons = {
  '===': function(l, r) {
    return l === r;
  },
  '>=': function(l, r) {
    return l >= r;
  },
  '>': function(l, r) {
    return l > r;
  },
  '<=': function(l, r) {
    return l <= r;
  },
  '<': function(l, r) {
    return l < r;
  }
};

function calculateIndices(breakpoint) {
  // read the :before pseudo element of body. there
  // is CSS that puts the name of the breakpoint there,
  // so JS can find out which breakpoint is currently 'active'
  var currSize = window
    .getComputedStyle(document.querySelector('body'), ':before')
    .getPropertyValue('content');

  // getting value above will bring quotes along for the ride,
  // strip them
  currSize = currSize.replace(/"/g, '');

  return {
    current: bodySizes.indexOf(currSize),
    breakpoint: bodySizes.indexOf(breakpoint)
  };
}

var compareAgainstBreakpoint = function(operator, breakpoint) {
  var indices = calculateIndices(breakpoint);

  if (indices.current === -1 || indices.breakpoint === -1 || !comparisons.hasOwnProperty(operator)) {
    return false;
  }

  return comparisons[operator](indices.current, indices.breakpoint);
};

module.exports = compareAgainstBreakpoint;

